import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../../components/tables/simpleTable';

import RecoverModal from '../../../components/modals/recoverModal';
import DeleteModal from '../../../components/modals/deleteModal';

import SearchFilter from '../../../components/filters/search';
import CustomButton from '../../../components/buttons/customButton';
import IsActiveFilter from '../../../components/filters/isActive';
import AddButton from '../../../components/buttons/addButton';
import DataFilter from '../../../components/filters/dataFilter';
import DatePicker from '../../../components/filters/datePicker';

import AsyncDropDownFilter from '../../../components/filters/asyncDropdownFilter';

import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter, trailBalanceFormatter } from '../../../components/formatters/numberFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { selectStyles } from '../../../components/dropDown/selectStyle';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FcViewDetails } from "react-icons/fc";

import { DataContext } from '../../../init/getData';


import ViewModal from '../../../components/modals/viewModal';





function SalesBySerial(props) {



  const { api, userData, categoryOptions, yearId, companyId, defaultCurrency, allUserOptions, customerAccountData,
    mainCurrency, refData, loadProductOptions, productOptions, branchOptions } = useContext(DataContext);



  const table = 'salesBySerial';
  const title = 'Sales By Serial';

  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);


  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const dataArray = ['branch', 'category', 'product', 'user', 'customerAccount']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', companyId, yearId, fromDate: today, toDate: today });



  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);


  // Account Options
  const accountOptions = customerAccountData?.map(item => ({
    value: item.id,
    label: (item?.parent?.accountId ? item?.parent?.accountId + '.' : '') + item.accountId + ' ' + item.english + ' [' + item.phone + ']',
  }));
  const loadAccountOptions = (inputValue, callback) => {
    const filteredOptions = inputValue ? accountOptions.filter(option =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];
    callback(filteredOptions);
  };


  const viewModal = (e) => {
    if (!showViewModal) {
      setIdRow(e);
    }
    setShowViewModal(!showViewModal);
  }



  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        Date: item.transaction?.journalVoucher?.date,
        Barcode: item.product?.barcode,
        Name: item.product?.name,
        Serial: item.serial,
        Qty: item.netQuantity,
        Customer: item.transaction?.journalVoucher?.account?.english,
        Price: item.totalPrice,
        Cost: item.totalCost,
        Profit: item.profit,
        "Jv-Id": item.transaction?.journalVoucher?.id,
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };

  const accountIdView = (id, record) => {
    if (record.parentId) {
      return <>{record.parent?.accountId + '.' + record.accountId}</>
    } else {
      return <>{record.accountId}</>
    }
  }

  const isUsingMainCurrency = defaultCurrency.id == mainCurrency.id ? true : false;

  let newColumnDefs = [
    { title: 'Date', dataIndex: 'transaction', render: (transaction) => (transaction?.journalVoucher?.date) },
    { title: 'Barcode', dataIndex: 'product', render: (product) => (product?.barcode) },
    { title: 'Name', dataIndex: 'product', render: (product) => (product?.name) },
    { title: 'Serial', dataIndex: 'serial' },
    { title: 'Qty', dataIndex: 'netQuantity' },
    { title: 'Customer', dataIndex: 'transaction', render: (transaction) => (transaction?.journalVoucher?.account?.english) },
    { title: 'Price', dataIndex: 'totalPrice', render: numberFormatter, sorter: (a, b) => a.age - b.age },
    { title: 'Cost', dataIndex: 'totalCost', render: numberFormatter, sorter: (a, b) => a.age - b.age },
    { title: 'Profit', dataIndex: 'profit', render: numberFormatter, sorter: (a, b) => a.age - b.age },
    { title: 'Jv-Id', dataIndex: 'transaction', render: (transaction) => (transaction?.journalVoucher?.id) },
    {
      title: 'View', 
      width: '5%',
      render: (_, record) => (
        <FcViewDetails size={20} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => viewModal(record)} />
      ),
    }

  ];


  const tableFooter = (
    <div style={{ textAlign: 'center', paddingRight: '120px' }}>
    </div>
  )



  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  }

  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <div>

          <Row className='g-2 mb-3'>

            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={4}>
              <DatePicker setFilter={setFilter} filter={filter} />
            </Col>

            <Col md={4}>
            </Col>


            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
            </Col>

          </Row>


          <Row className='g-2 mb-3'>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={categoryOptions}
                isSearchable={true}
                isClearable={true}
                required
                placeholder={'Select Category...'}
                value={categoryOptions?.find(option => option.value === filter.categoryId)}
                onChange={(e) => handleSelectChange(e, 'categoryId')}
              />
            </Col>


            <Col md={2}>
              <AsyncSelect
                styles={selectStyles}
                isClearable={true}
                cacheOptions
                defaultOptions
                loadOptions={loadProductOptions}
                isSearchable
                placeholder={'Select Product...'}
                value={productOptions?.find(option => option.value === filter.productId)}
                onChange={(e) => handleSelectChange(e, 'productId')}
              />
            </Col>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={allUserOptions}
                isSearchable={true}
                isClearable={true}
                required
                placeholder={'Select User...'}
                value={allUserOptions?.find(option => option.value === filter.userId)}
                onChange={(e) => handleSelectChange(e, 'userId')}
              />
            </Col>


            <Col md={2}>
              <AsyncSelect
                styles={selectStyles}
                isClearable={true}
                cacheOptions
                defaultOptions
                loadOptions={loadAccountOptions}
                isSearchable
                placeholder={'Select Customer...'}
                value={accountOptions?.find(option => option.value === filter.accountId)}
                onChange={(e) => handleSelectChange(e, 'accountId')}
              />
            </Col>


            <Col md={2}>
              <Select
                styles={selectStyles}
                options={branchOptions}
                isSearchable={true}
                isClearable={true}
                required
                placeholder={'Select Branch...'}
                value={branchOptions?.find(option => option.value === filter.branchId)}
                onChange={(e) => handleSelectChange(e, 'branchId')}
              />
            </Col>

          </Row>





          <SimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={newColumnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            selection={true}
            height={true}
          />


          <ViewModal
            showModal={showViewModal}
            toggleModal={viewModal}
            journalVoucherId={idRow?.transaction?.journalVoucher?.id}
          />



        </div>
      }


    </div>
  )
}

export default SalesBySerial;
